import React, { useState, useRef } from "react";
import { toast } from "react-toastify";
import { Modal, Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import { updateUserProfilePhoto } from "../../../services/AuthService";
import { useDispatch } from "react-redux";
import { updateProfileAction } from "../../../store/actions/AuthActions";

function ChangeProfilePhoto({ isPhoto, userRole }) {
  const [showModal, setShowModal] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileUrl, setSelectedFileUrl] = useState(null);
  const [isRemovePhoto, setIsRemovePhoto] = useState(false);
  const dispatch = useDispatch();

  const toggleModal = () => {
    if (!showModal) {
      setSelectedFile(null);
      setIsSubmitLoading(false);
    }
    setShowModal(!showModal);
  };

  const toggleRemove = () => {
    setIsRemovePhoto(!isRemovePhoto);
  };

  const fileInputRef = useRef(null);

  const handleFiles = (fileList) => {
    if (fileList.length) {
      const file = fileList[0];
      const allowedFileTypes = ['JPG', 'JPEG', 'PNG'];
      const fileExt = file.name.split('.').pop().toUpperCase();
      if (allowedFileTypes.includes(fileExt)) {
        setSelectedFile(file);
        const reader = new FileReader();
        reader.onload = () => setSelectedFileUrl(reader.result);
        reader.readAsDataURL(file);
      } else {
        toast.error('Please choose a valid file type (JPG, JPEG, PNG)');
      }
    } else {
      toast.error('Please choose a file');
    }
  };

  const handleDragOver = (e) => e.preventDefault();
  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const handleFileInputChange = (e) => handleFiles(e.target.files);
  const handleFileRemove = (e) => {
    setSelectedFile(null);
    e.stopPropagation();
  };

  const handleUpload = async () => {
    const formBody = new FormData();
    formBody.append('profile_photo', selectedFile);
    try {
      setIsSubmitLoading(true);
      const resp = await updateUserProfilePhoto(formBody);
      const { results, message } = resp.data;
      dispatch(updateProfileAction({ profile_photo: results }));
      toast.success(message);
      toggleModal(false);
      setIsSubmitLoading(false);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Upload failed');
      setIsSubmitLoading(false);
    }
  };

  const handleRemove = async () => {
    const formBody = new FormData();
    formBody.append("remove_profile", "YES");
    try {
      setIsSubmitLoading(true);
      const resp = await updateUserProfilePhoto(formBody);
      const { results, message } = resp.data;
      dispatch(updateProfileAction({ profile_photo: results }));
      toast.success(message);
      toggleModal(false);
      setIsSubmitLoading(false);
    } catch (error) {
      toast.error(error.response.data.message);
      setIsSubmitLoading(false);
    }
  };

  return (
    <>
    {userRole !== "Visitor" && (
        <div className="d-flex align-items-center justify-content-between">
        {isRemovePhoto ? (
          <div className="d-flex align-items-center flex-column border rounded mt-2 p-2">
            <span className="text-center">Confirm To Remove Profile Photo.</span>
            <div className="d-flex align-items-center justify-content-center mt-2">
              <button className="btn btn-danger btn-sm" disabled={isSubmitLoading} onClick={handleRemove}>
                YES
              </button>
              <button className="btn btn-outline-primary btn-sm ms-2" disabled={isSubmitLoading} onClick={toggleRemove}>
                NO
              </button>
            </div>
          </div>
        ) : (
          <div
            style={{
              position: 'absolute',
              bottom: -2,
              width: '101%',
              color: '#fff',
              textAlign: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              cursor: 'pointer',
            }}
          >
            <button className="btn btn-outline-primary btn-sm border-0 text-white" onClick={toggleModal}>
              {isPhoto ? 'Change Profile Photo' : 'Change Photo'}
            </button>
          </div>
        )}
      </div>
    )}

      <Modal show={showModal} centered onHide={toggleModal}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="fa fa-image me-2"></i> Change Profile Photo
            </h5>
            <button type="button" className="btn-close" onClick={toggleModal}></button>
          </div>
          <div className="modal-body">
            <div
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              className="dropzone"
              onClick={() => fileInputRef.current.click()}
            >
              <input
                type="file"
                ref={fileInputRef}
                multiple
                accept=".jpg, .jpeg, .png"
                onChange={handleFileInputChange}
                style={{ display: "none" }}
              />
              {selectedFile ? (
                <div className="file-preview" style={{ position: "relative" }}>
                  {selectedFileUrl && (
                    <img
                      src={selectedFileUrl}
                      alt="Selected"
                      className="preview-image"
                    />
                  )}
                  <div className="file-info mt-2 d-flex justify-content-center align-items-center">
                    <span className="file-name">
                      <i className="fa fa-file-image-o me-1"></i> {selectedFile.name}
                    </span>
                    <span className="file-remove" onClick={handleFileRemove}>
                      <i className="fa fa-times text-danger"></i>
                    </span>
                  </div>
                </div>
              ) : (
                <p className="dropzone-text">
                  <i className="fa fa-upload fs-3 mb-2 text-primary"></i>
                  <br />
                  Drag & drop an image here, or <span className="text-primary">click to select</span>
                  <br />
                  <strong className="fs-6">Allowed formats: JPEG, JPG, PNG</strong>
                </p>
              )}
            </div>

            <div className="d-flex justify-content-center mt-4">
              <button
                className="btn btn-primary w-50"
                disabled={isSubmitLoading || !selectedFile}
                onClick={handleUpload}
              >
                {isSubmitLoading ? (
                  <>
                    <Spinner animation="border" size="sm" /> Uploading...
                  </>
                ) : (
                  <>
                    <i className="fa fa-upload me-2"></i> Upload
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => ({
  userRole: state.auth.user?.role || "User",
});

export default connect(mapStateToProps)(ChangeProfilePhoto);
